__turbopack_context__.v({
  "className": "OR32JW_className",
  "variable": "OR32JW_variable",
});
